import { Box, styled } from '@mui/material';
import { IconButton } from 'components/mrp/components/AppointmentForm/AppointmentForm.styles';

export const SelectedEntityContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  paddingLeft: theme.spacing(2),
  marginBottom: theme.spacing(1),
  backgroundColor: theme.vars.palette.Button.inheritContainedHoverBg,
  borderRadius: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}));

export const EntityActionButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: 'transparent',
  height: `calc(36px - ${theme.spacing(1)})`
}));

export const SelectedEntityLabel = styled(Box)({
  display: 'flex',
  flexDirection: 'column'
});

// The derived treatment sits under the care receiver's name as a quiet subtitle: it is context
// for the appointment, not something the planner picks here.
export const SelectedEntityTreatment = styled(Box)(({ theme }) => ({
  fontSize: theme.typography.caption.fontSize,
  color: theme.vars.palette.text.secondary
}));
